export function eventViewFunc() {
    $("#iframeSet").on("load", function () {    
        try {        
            $(this).height(0);        
            $(this).height(this.contentWindow.document.documentElement.scrollHeight);    
        } catch (e) {}
    });
    $("#iframeSet").trigger("load");
}